import * as tslib_1 from "tslib";
import { OnDestroy, OnInit, } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import cloneDeep from 'lodash-es/cloneDeep';
import isEqual from 'lodash-es/isEqual';
/*
Due to the fact that IE marks controls as dirty when placeholders are present.
Until there's an official fix in @angular/forms, we'll override the FG directive.
*/
var UiFormGroupDirective = /** @class */ (function (_super) {
    tslib_1.__extends(UiFormGroupDirective, _super);
    function UiFormGroupDirective() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Cache the form values when value changes occur.
         * Values get cached only if the new value is set while the input is pristine (initial load).
         * Forms will be by default pristine if the old values are present.
         */
        _this._cache = {};
        return _this;
    }
    UiFormGroupDirective.prototype.ngOnInit = function () {
        var _this = this;
        {
            var keys = Object.keys(this.form.controls);
            for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                var key = keys_1[_i];
                this._updateCacheValueFor(key, this.form.controls[key].value);
            }
        }
        if (!this._valueSub || this._valueSub.closed) {
            this._valueSub = this.form.valueChanges.subscribe(function (change) {
                var keys = Object.keys(_this.form.controls);
                // clear cache entry for removed controls
                var staleKeys = Object.keys(_this._cache).filter(function (k) { return !keys.includes(k); });
                for (var _i = 0, staleKeys_1 = staleKeys; _i < staleKeys_1.length; _i++) {
                    var key = staleKeys_1[_i];
                    delete _this._cache[key];
                }
                // evaluate and set cache for a newly initialized form group
                for (var _a = 0, keys_2 = keys; _a < keys_2.length; _a++) {
                    var key = keys_2[_a];
                    _this._updateCacheValueFor(key, change[key]);
                }
            });
        }
        // overload reset method to include cache clearing
        var reset = this.form.reset.bind(this.form);
        this.form.reset = function (value, options) {
            _this._cache = {};
            reset(value, options || {
                onlySelf: true,
                emitEvent: true,
            });
        };
    };
    UiFormGroupDirective.prototype.ngOnDestroy = function () {
        if (this._valueSub) {
            this._valueSub.unsubscribe();
        }
    };
    UiFormGroupDirective.prototype._updateCacheValueFor = function (key, value) {
        value = !!value ? cloneDeep(value) : value;
        var control = this.form.get([key]);
        if (value == null) {
            if (!this._cache.hasOwnProperty(key) ||
                this._cache === '') {
                this._cache[key] = '';
                control.markAsPristine();
            }
            return;
        }
        if (control.pristine &&
            !isEqual(this._cache[key], value)) {
            this._cache[key] = value;
            control.markAsPristine();
        }
        else if (isEqual(this._cache[key], value)) {
            control.markAsPristine();
        }
    };
    return UiFormGroupDirective;
}(FormGroupDirective));
export { UiFormGroupDirective as FormGroupDirective };
